export default __webpack_public_path__ + "static/viinitie-banner-wedding-desktop-extra-wide.bf4fa40c412ef29c3dc7a1fc21d5f2ab.webp";